import { useSharedGlobalState } from '../hooks/useSharedGlobal';
export const constant = {
    access_token: 'ACCESS_TOKEN',
    refresh_token: 'REFRESH_TOKEN',
    expires_in: 'EXPIRES_IN',
    token_expires_time: 'TOKEN_EXPIRES_TIME',
    user_info: 'USER_INFO',
    user_name: 'USER_NAME',
    sessionId: 'sessionId',
};
/**
 * KXGC : 可信工程
 * LABOR : 劳务
 * OSS : OSS
 * GOV : 政府
 * SCM : 供应链
 * PSI : 内部供应链
 */
export const ENV = {
    KXGC: 'KXGC',
    LABOR: 'LABOR',
    OSS: 'OSS',
    GOV: 'GOV',
    SCM: 'SCM',
    PSI: 'PSI',
    GROUP: 'GROUP',
    COMPANY: 'COMPANY',
    BANK: 'BANK',
};
// export const SYSTRM_NAME_MAP = {
//   SCM: '可信供应链',
//   PSI: '鲁班物资管理',
//   KXGC: '可信工程',
// };
export const getSystemNameMap = () => {
    return useSharedGlobalState.getState().systemNameMap || {};
};
// export const ENV_MAP = {
//   [ENV.KXGC]: {
//     devUrl: 'http://ymsl.kxgcc.com:30872',
//     testUrl: 'https://test-ymsl.kxgcc.com:30195',
//     name: '可信工程平台',
//   },
//   [ENV.LABOR]: {
//     devUrl: 'http://ymsl-yj.kxgcc.com:30872',
//     testUrl: 'https://test-yj.kxgcc.com:30195',
//     name: '',
//   },
//   [ENV.OSS]: {
//     devUrl: 'http://dev-oss.kxgcc.com:30872',
//     testUrl: 'https://test-oss.kxgcc.com:30195',
//     name: '',
//   },
//   [ENV.GOV]: {
//     devUrl: 'http://dev-gov.kxgcc.com:32238',
//     testUrl: 'https://test-gov.kxgcc.com:30195',
//     name: '政府监管平台',
//   },
//   [ENV.SCM]: {
//     devUrl: 'http://dev-scm.kxgcc.com:30872',
//     testUrl: 'https://test-scm.kxgcc.com:30195',
//     name: '可信供应链平台',
//   },
//   [ENV.PSI]: {
//     devUrl: 'http://dev-psi.kxgcc.com:30872',
//     testUrl: 'https://test-psi.kxgcc.com:30195',
//     name: '鲁班物资管理平台',
//   },
//   [ENV.GROUP]: {
//     devUrl: 'http://dev-group.kxgcc.com:30872',
//     testUrl: 'https://test-group.kxgcc.com:30195',
//     name: '',
//   },
//   [ENV.COMPANY]: {
//     devUrl: 'http://dev-company.kxgcc.com:30872',
//     testUrl: 'https://test-company.kxgcc.com:30195',
//     name: '',
//   },
//   [ENV.BANK]: {
//     devUrl: 'http://dev-bank.kxgcc.com:30872',
//     testUrl: 'https://test-bank.kxgcc.com:30195',
//     name: '可信金融平台',
//   },
// } as const;
// export const ENV_MAP = useSharedGlobalState.getState().systemMap as any;
// console.log('我是配置');
export const getEnvMAP = () => {
    return useSharedGlobalState.getState().systemMap;
};
export const pubUrl = 'https://pub.kxgcc.com';
export const UIMS_BASE = '/uims';
